import { render, staticRenderFns } from "./InformationAssetComponent.vue?vue&type=template&id=e991c962&"
import script from "./InformationAssetComponent.vue?vue&type=script&lang=js&"
export * from "./InformationAssetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports